import { PatientHistoryType } from 'src/graphql.generated'
import { SUM_SCORED_QUESTIONS } from './sumScoredQuestionnaires'
import { Section, value } from './historyLayoutKit'

// Standard's PHQ-9 and GAD-7 block; its answers live under `PHQ9.QUESTION1`, not `PHQ9_QUESTION_1`.
const block = (title: string, prefix: string, type: PatientHistoryType, root: string): Section => {
  const questions = (SUM_SCORED_QUESTIONS[type] ?? []).filter(({ key }) => key.includes('_QUESTION_'))

  return {
    title,
    readOnly: true,
    fields: [
      ...questions.map(({ label }, index) => value(label, `${root}.${prefix}.QUESTION${index + 1}`)),
      value('Score', `${root}.${prefix}.TOTAL_SCORE`),
    ],
  }
}

export const PHQ9_GAD7_SECTIONS = (root: string): Section[] => [
  block('Health Questionnaire — PHQ-9', 'PHQ9', PatientHistoryType.Phq9, root),
  block('Health Questionnaire — GAD-7', 'GAD7', PatientHistoryType.Gad7, root),
]
